module.exports = __webpack_public_path__ + "static/pattern-f9fcb6d7ede9e496f3b839db84aae207.jpg";